var _style, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _g3, _g4, _g5, _g6, _g7, _g8, _path7, _path8, _path9, _path10, _circle, _path11, _path12, _path13, _path14, _ellipse, _path15, _path16, _path17, _polyline, _polyline2, _polyline3, _polyline4, _circle2, _circle3, _circle4, _circle5, _line, _path18, _path19, _ellipse2, _g9, _circle6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeEmptyMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 276.1 251.5",
    style: {
      enableBackground: "new 0 0 276.1 251.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#676767;stroke-width:1.7377;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:none;stroke:#676767;stroke-width:1.7377;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:2.645,2.645;}\n\t.st2{fill:none;stroke:#676767;stroke-width:1.7377;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:2.674,2.674;}\n\t.st3{fill:none;stroke:#676767;stroke-width:1.7377;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:2.5262,2.5262;}\n\t.st4{fill:#FFFFFF;stroke:#676767;stroke-width:2.0345;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#676767;stroke-width:2.0345;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#010101;stroke-width:1.1734;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st7{fill:none;stroke:#818181;stroke-width:1.2113;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#818181;stroke-width:0.9975;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st9{fill:none;stroke:#818181;stroke-width:1.0018;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st10{fill:none;stroke:#818181;stroke-width:0.969;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st11{fill:#F9D7E3;}\n\t.st12{opacity:0.2;fill:#F9D7E3;enable-background:new    ;}\n\t.st13{fill:#FFFFFF;}\n\t.st14{fill:none;stroke:#868484;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st15{fill:none;stroke:#676767;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 177.8,
    y1: 164,
    x2: 179.1,
    y2: 164
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 181.7,
    y1: 164,
    x2: 217.5,
    y2: 164
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "218.8,164 220.1,164 220.1,165.3  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 220.1,
    y1: 168,
    x2: 220.1,
    y2: 246.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 220.1,
    y1: 248.2,
    x2: 220.1,
    y2: 249.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 66.1,
    y1: 249.5,
    x2: 66.1,
    y2: 248.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 66.1,
    y1: 245.5,
    x2: 66.1,
    y2: 166.6
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "66.1,165.3 66.1,164 67.4,164  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 69.9,
    y1: 164,
    x2: 104,
    y2: 164
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 105.3,
    y1: 164,
    x2: 106.6,
    y2: 164
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M153.4,88c0,0,25.9,66.4,17.9,74.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M132.8,88c0,0-25.9,66.4-17.9,74.6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M177.5,163.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M165,119.7l0.9,1.4c1.1,1.8,3.8,1.9,4.9,0.1l11.2-17c0,0,9.4,1.5,14.4-7.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M44.3,110.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M200.4,66.4c-1.7-1.3-4.5-1-5.8,0.7s-1,4.5,0.6,5.8s4.4,1.1,5.8-0.6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M242.6,147.7c-1.4-1.1-3.7-0.8-4.8,0.6c-1.1,1.4-0.9,3.7,0.5,4.8s3.7,0.9,4.8-0.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1,128.1c-0.2-2.3,1.5-4.6,3-4.1s2.4,3.7,1.5,5.6"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 260.8,
    y1: 66,
    x2: 253.8,
    y2: 73
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 253.8,
    y1: 66,
    x2: 260.8,
    y2: 73
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 275.1,
    y1: 59.7,
    x2: 269.5,
    y2: 65.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 269.5,
    y1: 59.7,
    x2: 275.1,
    y2: 65.3
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 45.8,
    y1: 52,
    x2: 38.8,
    y2: 59
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 38.8,
    y1: 52,
    x2: 45.8,
    y2: 59
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 102.1,
    y1: 2.7,
    x2: 96.5,
    y2: 8.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 96.5,
    y1: 2.7,
    x2: 102.1,
    y2: 8.3
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 42.1,
    y1: 153.7,
    x2: 36.5,
    y2: 159.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 36.5,
    y1: 153.7,
    x2: 42.1,
    y2: 159.3
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 84.1,
    y1: 237.7,
    x2: 78.5,
    y2: 243.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 78.5,
    y1: 237.7,
    x2: 84.1,
    y2: 243.3
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M58.3,102.7c-2.9,0.1-5.2,3.4-4.3,6.2s4.8,4,7.2,2.3c2.4-1.7,2.4-5.8,0-7.5c-1.1-0.2-2.3-0.5-3.4-0.7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M194.4,227.9c-2.5-1.4-6.2,0.1-7,2.9s1.3,6,4.1,6.5s5.8-1.7,6.4-4.5c0.3-1.8-0.7-4.1-2.6-4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M216.3,37c2.4-0.2,4.8-0.7,7-1.5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M246.6,129.6c-0.7-3,1.7-6.3,4.7-6.7c0.7-0.1,1.2,0.6,1.6,1.2c1.1,1.7,1.8,3.8,1.2,5.7 C253.5,131.7,248.3,130.6,246.6,129.6z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 143.1,
    cy: 68.5,
    r: 26.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M143.8,165"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M143.8,165"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M143.8,169c0,0,23-7,29-6c7.6,1.3,12,2,13,28v20c0,0,6-7,18-3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M143.8,169c0,0-23-7-29-6c-7.6,1.3-12,2-13,28v20c0,0-6-7-18-3"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11",
    cx: 143.7,
    cy: 79.5,
    rx: 4.5,
    ry: 3.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M121.3,119.7l-0.9,1.4c-1.1,1.8-3.8,1.9-4.9,0.1l-11.2-17c0,0-9.4,1.5-14.4-7.2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M168.2,16.3c0.3-1.9,1.3-3.7,2.9-4.7c1.6-1,3.8-1.2,5.4-0.2c1.6,1,2.5,3.2,1.8,4.9c-0.8,2-3,2.8-4.7,4.1 c-2.2,1.8-3.4,4.6-3.1,7.4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M169.5,31.3c-0.4-0.7-1.6-0.8-2.1-0.1s-0.3,1.7,0.4,2.2c0.6,0.5,1.6,0.5,2.3,0.2c0.3-0.1,0.5-0.3,0.7-0.5 c0.6-0.8-0.1-2.1-1.1-2.1"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st11",
    points: "141.3,108 149.8,139 141.3,151 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st11",
    points: "141.3,110.4 134.8,139.6 141.3,151 "
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "142.8,100 150.8,136 142.8,150 "
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "142.8,100 134.8,136 142.8,150 "
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 142.8,
    cy: 100,
    r: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 142.8,
    cy: 99,
    r: 4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 217.9,
    cy: 227.3,
    r: 10.2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 217.9,
    cy: 227.3,
    r: 8.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 225.2,
    y1: 234.5,
    x2: 231.3,
    y2: 240.7
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M226,239.8l6.7,6.7c0.9,0.9,2.4,0.9,3.3,0l0,0c0.9-0.9,0.9-2.4,0-3.3l-6.7-6.7L226,239.8z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M227.7,240.4l6.7,6.7c0.9,0.9,2.4,0.9,3.3,0l0,0c0.9-0.9,0.9-2.4,0-3.3l-6.7-6.7L227.7,240.4z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5307 -0.8475 0.8475 0.5307 -85.3389 290.4489)",
    className: "st13",
    cx: 219.6,
    cy: 222.3,
    rx: 1.9,
    ry: 2.6
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M133.5,62.7"
  })))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 316.3,
    cy: 133.5,
    r: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeEmptyMessage);
export default __webpack_public_path__ + "static/media/homeEmptyMessage.73e820e40013510759320d3fcd146697.svg";
export { ForwardRef as ReactComponent };